// extracted by mini-css-extract-plugin
module.exports = {"step":"step___1Ir-I","desc":"desc___3V6bT","checkboxWrapper":"checkboxWrapper___jSAR6","checkboxCorrect":"checkboxCorrect___36O2s","checkboxIncorrect":"checkboxIncorrect___2f1_k"};